import { responsiveMediaAbove, ResponsiveOptions } from "../settings/responsive";
import { CLASS_OPEN } from "../tools/constants/classes";
import { AccordionSlide, SELECTOR_SUMMARY } from "./AccordionSlide";

// Selectors
const SELECTOR_SLIDE = '[data-accordion-slide]';

export class Accordion {
  private container:HTMLElement;
  private accordionSlideElements:HTMLDetailsElement[]|null = null;
  private accordionSlides:AccordionSlide[] = [];
  private disableSize:ResponsiveOptions|null = null;

  constructor(container:HTMLElement, disableSize?:ResponsiveOptions) {
    this.container = container;
    this.accordionSlideElements = Array.from(container.querySelectorAll<HTMLDetailsElement>(SELECTOR_SLIDE));
    if(disableSize) this.disableSize = disableSize;

    this.attachEvents();
  }

  public openAccordion() {
    if(!this.accordionSlideElements) return;

    if(this.container.classList.contains(CLASS_OPEN)) return;
    this.container.classList.add(CLASS_OPEN);

    this.accordionSlideElements.forEach(element => element.setAttribute('open', 'open'));
  }

  public closeAccordion() {
    if(!this.accordionSlideElements) return;

    if(!this.container.classList.contains(CLASS_OPEN)) return;
    this.container.classList.remove(CLASS_OPEN);

    this.accordionSlideElements.forEach(element => element.removeAttribute('open'));
  }

  private closeActiveSlides(e:Event, activeSlide:HTMLDetailsElement) {
    if(!this.accordionSlides || this.accordionSlides.length == 0) return;

    this.accordionSlides.forEach(slide => {
      if(slide.el == activeSlide || !slide.el.open) return;

      slide.onClick(e);
    });
  }

  private onSlideClick(e:Event, index:number) {
    if(!this.accordionSlides || this.accordionSlides.length == 0) return;

    const slide = this.accordionSlides[index];
    if(!slide) return;

    this.closeActiveSlides(e, slide.el);
    slide.onClick(e);
  }

  public attachEvents() {
    if(this.accordionSlideElements && this.accordionSlideElements.length > 0) {
      this.accordionSlideElements.forEach((slideElement, i) => {
        const newSlide = new AccordionSlide(slideElement);
        this.accordionSlides.push(newSlide);

        const slideSummary = slideElement.querySelector<HTMLElement>(SELECTOR_SUMMARY);
        if(slideSummary) {
          slideSummary.addEventListener('click', e => this.onSlideClick(e, i));
        }
      });
    }
  }

  public detachEvents() {
    if(this.accordionSlideElements && this.accordionSlideElements.length > 0) {
      this.accordionSlideElements.forEach((slideElement, i) => {
        const slideSummary = slideElement.querySelector<HTMLElement>(SELECTOR_SUMMARY);

        if(slideSummary) {
          slideSummary.removeEventListener('click', e => this.onSlideClick(e, i));
        }
      });
    }
  }
}
